// TODO: Fix this the next time the file is edited.
// eslint-disable-next-line import/order
import React from 'react';
import CurrencyFormat from 'react-currency-format';

// TODO: Fix this the next time the file is edited.
// eslint-disable-next-line react/prop-types
export default ({ value }) => (
  <CurrencyFormat
    value={value}
    thousandSeparator
    displayType='text'
    prefix='$'
  />
);
